import { render, staticRenderFns } from "./GridPerson.vue?vue&type=template&id=195a0f1d&scoped=true&"
import script from "./GridPerson.vue?vue&type=script&lang=js&"
export * from "./GridPerson.vue?vue&type=script&lang=js&"
import style0 from "./GridPerson.vue?vue&type=style&index=0&id=195a0f1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a0f1d",
  null
  
)

export default component.exports